/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetLedgerModuleOptions, GetLedgerModuleResponses } from '../types/GetLedgerModule'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get the entire module object, including unborrowed leverage assets and total leverage trackers
 * {@link /v1/ledger/module}
 */
export function getLedgerModule<ThrowOnError extends boolean = true>(
  options: Options<GetLedgerModuleOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetLedgerModuleResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/module',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetLedgerModuleResponses, ThrowOnError>>,
  )
}
